export const MARKETPLACE_CATEGORIES = [
  'Housing', 'Furniture', 'Electronics', 'Kitchenware', 'HomeAppliances',
  'Clothing', 'BabyProducts', 'KidProducts', 'Vehicles', 'Books', 'Tools', 'Sports', 'Other',
] as const;

export const MARKETPLACE_EMOJI: Record<string, string> = {
  Housing: '🏠', Furniture: '🛋️', Electronics: '📱', Kitchenware: '🍳',
  HomeAppliances: '🏠', Clothing: '👕', BabyProducts: '🍼', KidProducts: '🧸',
  Vehicles: '🚗', Books: '📚', Tools: '🔧', Sports: '⚽', Other: '🛒',
};

export const MARKETPLACE_GRADIENT: Record<string, string> = {
  Housing:       'linear-gradient(135deg, #0ea5e9 0%, #0c4a6e 100%)',
  Furniture:     'linear-gradient(135deg, #a16207 0%, #451a03 100%)',
  Electronics:   'linear-gradient(135deg, #6366f1 0%, #1e1b4b 100%)',
  Kitchenware:   'linear-gradient(135deg, #ef4444 0%, #7f1d1d 100%)',
  HomeAppliances:'linear-gradient(135deg, #64748b 0%, #1e293b 100%)',
  Clothing:      'linear-gradient(135deg, #ec4899 0%, #500724 100%)',
  BabyProducts:  'linear-gradient(135deg, #f59e0b 0%, #78350f 100%)',
  KidProducts:   'linear-gradient(135deg, #8b5cf6 0%, #4c1d95 100%)',
  Vehicles:      'linear-gradient(135deg, #475569 0%, #0f172a 100%)',
  Books:         'linear-gradient(135deg, #10b981 0%, #064e3b 100%)',
  Tools:         'linear-gradient(135deg, #78716c 0%, #1c1917 100%)',
  Sports:        'linear-gradient(135deg, #16a34a 0%, #14532d 100%)',
  Other:         'linear-gradient(135deg, #6b7280 0%, #111827 100%)',
};
